import React from 'react';

export default function NotificationsSkeleton() {
  return (
    <div className="page-skeleton notifications-skeleton">
      <div className="skeleton-card notifications-skeleton-status">
        <div className="skeleton-row">
          <div className="skeleton-circle" style={{ width: 52, height: 52 }} />
          <div className="skeleton-lines">
            <div className="skeleton-block" style={{ height: 16, width: '45%' }} />
            <div className="skeleton-block" style={{ height: 12, width: '70%' }} />
          </div>
          <div className="skeleton-block skeleton-pill" />
        </div>
      </div>

      <div className="skeleton-card notifications-skeleton-panel">
        <div className="skeleton-block" style={{ height: 18, width: '35%', marginBottom: 16 }} />
        <div className="skeleton-block" style={{ height: 12, width: '85%', marginBottom: 8 }} />
        <div className="skeleton-block" style={{ height: 12, width: '60%', marginBottom: 24 }} />

        <div className="skeleton-block" style={{ height: 12, width: 48, marginBottom: 8 }} />
        <div className="skeleton-block" style={{ height: 44, width: '100%', marginBottom: 20 }} />

        <div className="skeleton-row" style={{ gap: 10 }}>
          <div className="skeleton-block" style={{ flex: 1, height: 44 }} />
          <div className="skeleton-block" style={{ height: 44, width: 110 }} />
        </div>
      </div>

      <div className="skeleton-card notifications-skeleton-note">
        <div className="skeleton-row">
          <div className="skeleton-circle" style={{ width: 32, height: 32 }} />
          <div className="skeleton-lines">
            <div className="skeleton-block" style={{ height: 12, width: '55%' }} />
            <div className="skeleton-block" style={{ height: 10, width: '40%' }} />
          </div>
        </div>
      </div>
    </div>
  );
}
